const userReducer = (state = {}, action) => {

    switch (action.type) {
        case "USERS_LOADED_SUCCESS":
            return Object.assign({}, state, {
                getUser: action.data,
            });
        case "USER_UPDATE_SUCCESS":
            console.log(action.data);
            return Object.assign({}, state, {
                updateUser: action.data,
            });
        case "USER_LOADED_SUCCESS":
            console.log(action.data);
            return Object.assign({}, state, {
                getParticularUser: action.data,
            });
        case "USER_ADDED_SUCCESS":
            console.log(action.data)
            return Object.assign({}, state, {
                addUser: action.data,
            });
        case "USER_API_SUCCESS":
            return Object.assign({}, state, {
                isApiSuccess: action.data,
            });
        case "VERIFY_INVITE_LINK":
            return Object.assign({}, state, {
                VerifyInviteFromLink: action.data,
            });
        case "RESET_API":
            return Object.assign({}, state, {
                resetpassword: action.data,
            });
        case "USER_DELETED":
            console.log(action.data);

            return Object.assign({}, state, {
                deleteUser: action.data,
            });
        case "USER_GET_SUCCESSFULL":
            return Object.assign({}, state, {
                getParticularUser: action.data,
            });
            case "SUCCESS":
                return Object.assign({}, state, {
                    success: action.data,
                });
        case "BG_LOADER":
            console.log(action.data);
            
            return Object.assign({}, state, {
                BG_LOADER: action.data
            });
            case "BG_HOME_LOADER":
            console.log(action.data);
            
            return Object.assign({}, state, {
                BG_HOME_LOADER: action.data
            });
        case "PASSWORD_CHANGED":
            console.log(action.data);

            return Object.assign({}, state, {
                changePassword: action.data,
            });
        default:
            return state;
    }
};

export default userReducer;